import { Link } from 'react-router'
import clsx from 'clsx'

type LinkArrowProps = {
  href: string
  children: React.ReactNode
  external?: boolean
  className?: string
  ariaLabel?: string
}

export const LinkArrow = ({
  href,
  children,
  external = false,
  className = '',
  ariaLabel,
}: LinkArrowProps) => {
  const content = (
    <>
      {children} <span>→</span>
    </>
  )

  if (external) {
    return (
      <a
        href={href}
        className={clsx('link-arrow', className)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel}
      >
        {content}
      </a>
    )
  }

  return (
    <Link
      to={href}
      className={clsx('link-arrow', className)}
      aria-label={ariaLabel}
    >
      {content}
    </Link>
  )
}
